import styled from 'styled-components';
import { Icon } from '../icon';

export const FullscreenLayout = styled.div`
    position: fixed;
    inset: 0 var(--help-panel-width, 0px) 0 0;
    background: #f5f7fa;
    z-index: 20;
    transition: right 0.3s ease;
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 0;
`;

export const FullscreenIframeTopBar = styled.div<{ $discovery?: boolean }>`
    position: relative;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 12px 24px;
    background: ${(props) => (props.$discovery ? 'linear-gradient(135deg, #E8650A 0%, #E6167F 100%)' : 'white')};
    border-bottom: 1px solid ${(props) => (props.$discovery ? '#E6167F' : '#e2e8f0')};
    min-height: 64px;
    transition: border-color 0.25s ease;
`;

export const FullscreenIframeTopBarLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const FullscreenIframeTopBarCenter = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const FullscreenIframeTopBarRight = styled.div`
    position: absolute;
    right: 24px;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const FullscreenIframeTitle = styled.h3<{ $discovery?: boolean }>`
    font-size: 18px;
    font-weight: 600;
    color: ${(props) => (props.$discovery ? '#ffffff' : '#1e293b')};
    margin: 0;
`;

export const FullscreenIframeCloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: #000000;
    color: #ffffff;
    cursor: pointer;
    transition: background 0.2s ease;
    flex-shrink: 0;

    &:hover {
        background: #333333;
    }

    ${Icon} {
        width: 16px;
        height: 16px;
        min-width: 0;
        fill: currentColor;
    }
`;

export const FullscreenIframeContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    padding: 20px 24px;
    overflow: auto;
`;

export const FullscreenIframeFrameContainer = styled.div`
    flex: 1;
    position: relative;
    background: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    overflow: hidden;
    min-height: 620px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const FullscreenIframe = styled.iframe`
    width: 100%;
    height: 100%;
    min-height: 620px;
    border: 0;
`;
